// WhyCruise.js
import React, { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import '../style2.css' ;
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import Whyimage from "../assets/cruisedeal header copy.jpg";
import CruiseAdventure1 from "../assets/Entertain.jpg";
import CruiseAdventure2 from "../assets/Family.jpg" ;
import CruiseAdventure3 from "../assets/FlowRider.jpg";
import Destination1 from "../assets/Ovation.jpg" ;
import Destination2 from "../assets/EUROPE.jpg" ;
import Destination3 from "../assets/edge.jpg" ;
import ScrolltoTop from '../components/ScrolltoTop';
import UtmUpdate from '../components/WhatsAppUTMLinkUpdater';



const faqs = [
  {
    question: "I'll be stuck onboard",
    answer:
      "Not really. Even while a ship sails from port to port, there are plenty of activities that a traveler can do onboard. However, depending on how many sea days your trip itinerary entails, you’ll be on a new port each morning that you can explore leaving the ship. Apart from this, you also get a bouquet of exciting onboard activities to choose from. This ensures, you would never feel stuck onboard. Also, rest assured that in case you need to leave the ship anytime due to an emergency, the crew can make necessary arrangements."
  },
  {
    question: "Cruise ships are crowded",
    answer: "This used to be an issue with the older ships due to their poor layouts, but on modern, carefully designed cruise ships, it's not a problem. Moreover, with the world’s largest cruise ships like Harmony of the Seas and Symphony of the Seas, crowd is hardly a matter. Modern cruise ships are never congested, as the ships with more passengers also include more deck space, restaurants and entertainment venues to accommodate the larger number of people onboard. A cruise and its itineraries are carefully designed to let every passenger feel like a celebrity."
  },
  {
    question: "I'll get seasick",
    answer: "Probably not. In fact, there may be times when you don’t even realize the ship is moving. This is primarily due to the ship being equipped with stabilizers, which most cruise ships have nowadays. With that said, the ocean is a big place. If there are waves, you’ll likely feel them. So pack your favorite motion sickness remedy, just in case, and you should be good to go. If you’re still worried about getting seasick, book a cabin in the middle of the deck, which is the natural balance point on a cruise ship."
  },
  {
    question: "It's too expensive",
    answer: "You don’t have to be Bruce Wayne to take a cruise these days. With so much competition in the cruise space, companies are always looking to fill cabins and often offer discounts and incentives, to ensure their ships don’t leave the docks empty. Moreover, modern cruises start from about $100 a day. This includes all meals, entertainment, and serviced accommodation. You can also opt for a guaranteed stateroom to book in advance with the surety of a room when you travel and probability for an upgrade if possible."
  },
  {
    question: "The choice of food is limited and will not be fresh",
    answer: "On modern cruise ships, the choice of food is incredible, with many choices available for each meal, including various vegetarian options and many meats. Additionally, modern cruise lines now offer specialty dining, which—for an extra fee—gives cruisers the chance to elevate their culinary experience. Moreover, people with special dietary requirements, such as Jain food and vegans need not worry. They only need to mention this at the time of booking and they will be catered for."
  },
  {
    question: "Cruise ships are boring",
    answer: "Not at all! Cruise ships are floating resorts packed with exciting activities for all ages and interests. From rock climbing walls, surf simulators, zip lines, Broadway-style shows, themed parties, escape rooms, to dance classes and live music—there’s never a dull moment. Whether you prefer high-energy fun or laid-back relaxation at a spa or pool, cruise ships offer the perfect balance of thrill and chill."
  },
  {
    question: "Cruises are for old people who aren’t very active",
    answer: "That’s a common misconception. Today’s cruise lines cater to all age groups—especially younger, adventurous travelers. With activities like scuba diving, skydiving simulators, water slides, beach excursions, fitness boot camps, and nightlife that rivals any urban hotspot, cruises are full of energy. Whether you're a solo traveler, a young couple, or a group of friends, there’s plenty to keep you active and engaged from sunrise to well past sunset."
  },
  {
    question: "I can’t cruise alone",
    answer: "Cruising is one of the most social forms of travel, and cruising alone is a great way to meet new people. Look out for any solo-focused gatherings on the first few days of your cruise, request set-seating dining, and participate in the various onboard activities (karaoke, trivia and game shows) that will allow you to put yourself out there and meet people. Several ships have solo cabins, specially designed for people sailing by themselves. Some include access to dedicated solo lounges and activities geared towards those who are onboard without a travel companion."
  },
  {
    question: "I’ll never have any privacy",
    answer: "Modern cruise ships are designed with guest comfort in mind—including personal space. You’ll have your own private stateroom or suite, many with balconies for quiet moments overlooking the ocean. The ship is large enough that you can find peaceful corners like the library, adults-only retreats, private lounges, and even secluded spots on deck. Plus, with flexible dining times and custom excursions, you can shape your experience exactly how you like it."
  },
  {
    question: "All cabins are created equal",
    answer: "Not quite! Cruise ships offer a wide variety of staterooms tailored to different preferences and budgets. You can choose from interior cabins, ocean-view rooms, balcony staterooms, or luxurious suites with extra perks like concierge service and private lounges. Whether you're looking for a cozy space to rest or a lavish retreat with ocean views and more space, there's a cabin to match your needs. The diversity in cabin types ensures every guest can find the perfect option for their cruise experience."
  },
  {
    question: "I always need to stay dressed up",
    answer: "Cruising has gotten much less formal with time. With the plethora of casual activities, you will hardly be in a mood to always stay dressed up. Nowadays, most nights on a cruise, you'll only need ‘smart casual’ attire. And you can always skip the main dining room, which has a dress code. For a more casual meal, you can always visit a buffet or other more laid-back venues."
  },
  {
    question: "Kids will be bored",
    answer: "All major cruise lines offer organized programs and camps for children, who can choose to participate the whole day or only in specific activities. Some fun kids’ activities include Teen disco, Adventure science club, Aquanauts, Imagination Studio, Adventure Ocean Theatre, Adventure Art, along with special Babies and Tots Program. These activities provide for both family time, and a chance for the parents to relax on their own. Daycare and babysitting services are also available, usually at no charge."
  }
];

function WhyCruise() {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (

    <>

<UtmUpdate/>
    <Navbar/>

    <div className="header">
             <div className="offer-alert">
                 <div>
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                  </div>
                  <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
             </div>

             <div className='why-header-container'>
                <img src={Whyimage} alt='' />
             </div>
    </div>

    <div className="why-cruise-container">
      <div className="hero-image" />

      <section className="intro">
        <h1>Why Cruise</h1><br></br>
        <p>
          We all want to travel the world. But there is a category of travelers who don’t just want to travel the world,
          but experience it.
        </p>
        <p>
          They are not just tourists. They are cliff jumping, waterfall climbing, and monkey chasing adventure seekers.
          And a cruise is not just about tours. It’s a zip line conquering, ocean discovering, underwater adventure. It
          lets you explore island after island, culture after culture because cruise activities/itineraries are created
          with thousands of options for families, foodies, action lovers and culture seekers.
        </p>
        <p>
          That’s why a cruise denotes much more than merely a voyage. It signifies a way to have an experience of
          lifetime.

        </p>

        <br></br>

        <div className="why-cruise-gallery ">
          <img src={CruiseAdventure1} alt="Cruise Adventure 1" />
          <img src={CruiseAdventure2} alt="Cruise Adventure 2" />
          <img src={CruiseAdventure3} alt="Cruise Adventure 3" />
        </div>
       <br></br><br></br>
        <p>
          Contrary to the common belief, a modern cruise offers a more stress-free experience, as you don’t have to plan.
          Everything is taken care of by the cruise: food, accommodation, entertainment, planning (as to which port to be
          visited next) all is taken care of. At the end, it’s a very relaxing, convenient and hassle-free vacation.
        </p>

        <p>
          So, when it comes to cruise, there are plethora of options and itineraries catering to whatever your preference
          maybe. Basically, there are three kinds of cruises to be chosen from.
        </p>

        <div className="why-cruise-gallery2">
          <img src={Destination1} alt="Port Destination 1" />
          <img src={Destination2} alt="Port Destination 2" />
          <img src={Destination3} alt="Port Destination 3" />
          {/* <img src={Destination4} alt="Port Destination 4" /> */}
        </div>
       <br></br><br></br>
        <p>
          So, a cruise can let you travel the way you want. There’s something for everyone. Like for fitness aficionados,
          there are aplenty fitness options available onboard. Likewise for avid food-lovers, there are diverse type of
          cuisines available, at all times during the day.
        </p>

        <p>
          There’s so much to do on a cruise that you can’t help but be delighted. So, start living life, one cruise at a
          time.
        </p>
      </section>

      <section className="faq-section">
        <h2>Forget Myths and Woes</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div className="faq-item" key={index}>
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                {activeIndex === index ? <FaMinus /> : <FaPlus />}
              </button>
              {activeIndex === index && <div className="faq-answer">{faq.answer}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
    
    <ScrolltoTop/>
    <Footer/>
    </>
  );
}

export default WhyCruise;
